import { FC, PropsWithChildren, useEffect } from "react";
import { AuthProvider, useAuth } from "react-oidc-context";
import { useOIDCSettings } from "../../contexts";

type AuthWrapProps = PropsWithChildren;

const InternalAuthWrap: FC<AuthWrapProps> = ({ children }) => {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isLoading && !auth.isAuthenticated && !auth.activeNavigator) {
      auth.signinRedirect();
    }
  }, [auth.isAuthenticated, auth.isLoading, auth.activeNavigator]);

  return auth.isAuthenticated ? children : null;
};

const AuthWrap: FC<AuthWrapProps> = ({ children }) => {
  const settings = useOIDCSettings();

  return (
    <AuthProvider {...settings}>
      <InternalAuthWrap>{children}</InternalAuthWrap>
    </AuthProvider>
  );
};

export { AuthWrap };
